"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationKeys = exports.defaultTranslationKeysWithNamespaces = exports.LogoutConfirmDialogTranslationKeys = void 0;
/* eslint-disable @typescript-eslint/naming-convention -- Localization keys don't comply with camel case */

const LogoutConfirmDialogTranslationKeys = exports.LogoutConfirmDialogTranslationKeys = {
  DialogTitle: 'DialogTitle',
  DialogQuestion: 'DialogQuestion',
  ConfirmationLabel: 'ConfirmationLabel',
  CancelLabel: 'CancelLabel'
};
const translationKeys = exports.translationKeys = {
  ...LogoutConfirmDialogTranslationKeys
};
const defaultTranslationKeysWithNamespaces = exports.defaultTranslationKeysWithNamespaces = {
  'logout-confirm-dialog': LogoutConfirmDialogTranslationKeys
};
